import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Represents an error that is received from the server
 * You can access the response code via the code property, and the URI from the requestURI property.
 * The retried property will indicate whether or not the request failed after multiple tries.
 */
export var ServerError = /*#__PURE__*/function (_Error) {
  _inherits(ServerError, _Error);

  var _super = _createSuper(ServerError);

  function ServerError(message, code, requestURI) {
    var _this;

    var retried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, ServerError);

    _this = _super.call(this, message);
    _this.name = 'ServerError'; // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), ServerError);
    }

    _this.code = code;
    _this.requestURI = requestURI;
    _this.retried = retried;
    return _this;
  }

  return ServerError;
}( /*#__PURE__*/_wrapNativeSuper(Error));